
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ingresar",
      function () {
        return require("private-next-pages/ingresar/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ingresar"])
      });
    }
  